<template>
    <div class="no-displayed-recommendation">
        <div class="no-displayed-recommendation__art" aria-hidden="true">
            <MaltIllustration name="folders-lock--high" alt="" width="120" />
        </div>
        <VJoyText preset="primary-450" class="no-displayed-recommendation__title">
            {{ t('profile.section.appraisals.no.reviews.to.display.label') }}
        </VJoyText>
        <VJoyText preset="primary-300" class="no-displayed-recommendation__text">
            {{ t('profile.section.appraisals.no.reviews.freelancer.private.choice', {0: freelancerName}) }}
        </VJoyText>
    </div>
</template>

<script setup lang="ts">
    import {MaltIllustration} from '#components';
    import {useTranslation} from '#imports';
    import {VJoyText} from '@maltjoy/core-vue';

    defineProps<{freelancerName?: string}>();

    const {t} = useTranslation();
</script>

<style lang="scss" scoped>
    .no-displayed-recommendation {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        color: var(--joy-color-neutral-30);
        gap: var(--joy-core-spacing-2);
        padding: var(--joy-core-spacing-6) var(--joy-core-spacing-4);
    }
</style>
